import React, { useState } from 'react';
import { get } from './common/fetch';

export async function getComponentProps() {
  let careers;
  try {
    careers = await get('/career');
  } catch (e) {
    console.log(e);
  }

  return { careers: careers || [] };
}

const Careers = ({ careers }) => {
  const [activeKey, setActiveKey] = useState(careers.length ? careers[0].id : undefined);

  return (
    <section className="container space">
      {!!careers.length && <p>We are recruiting for the following roles:</p>}
      {careers.map((career) => (
        <div
          key={career.id}
          style={{
            backgroundColor: 'white',
            borderRadius: 5,
            padding: 10,
            margin: 10,
            cursor: activeKey !== career.id ? 'pointer' : 'default',
          }}
          onClick={() => setActiveKey(career.id)}
        >
          <h2 style={{ margin: 0 }}>{career.name}</h2>
          <div style={activeKey !== career.id ? { display: 'none' } : { marginTop: 10 }}>
            <div dangerouslySetInnerHTML={{ __html: career.details }} />
            <a
              href={`mailto:careers@aquinnahomes.com?subject=Job Application for ${career.name}&body=Please attach your CV`}
              className="btn btn-success"
            >
              Apply Now
            </a>
          </div>
        </div>
      ))}

      {/* <p>There are currently no opportunities available, please check back soon.</p> */}
    </section>
  );
};

export default Careers;
